import React from 'react';
import ConfirmationCheckbox from '../../../../composed/products/ConfirmationCheckbox';
import AtomicButton from '../../../../atomic/button/Button';
import { isTabDirty } from '../storeSettingsForm';
import { STORE_SETTINGS_CONFIRMATION_TEXT } from '../storeSettingsConstants';

export function StoreTabFooter({
  tabId,
  form,
  baseline,
  saveAcknowledged,
  setSaveAcknowledged,
  kitchenUpdateAPIResponse,
  uploadImage,
  handleTabUpdate,
  storeImageFile,
  storeFrontImageFiles,
}) {
  const dirty = isTabDirty(tabId, form, baseline, {
    pendingStoreImageFile: tabId === '1' ? storeImageFile : null,
    pendingStoreFrontImageFiles: tabId === '1' ? storeFrontImageFiles : null,
  });
  const saving =
    kitchenUpdateAPIResponse?.loading === true ||
    (tabId === '1' && uploadImage?.loading === true);
  const ready = baseline != null;
  const buttonDisabled = !ready || !dirty || !saveAcknowledged;
  const loadingLabel =
    saving && uploadImage?.loading ? 'Uploading image…' : saving ? 'Saving…' : '';

  return (
    <div className='store-settings-confirm-action-box'>
      <ConfirmationCheckbox
        agreed={saveAcknowledged}
        setAgreed={setSaveAcknowledged}
        confirmationText={STORE_SETTINGS_CONFIRMATION_TEXT}
        mustConfirmMessage='You must confirm before saving.'
        boxSx={{ mt: 0, maxWidth: '100%' }}
      />
      <div className='store-settings-confirm-button-wrap'>
        <AtomicButton
          label={loadingLabel || 'UPDATE STORE SETTINGS'}
          handleSubmit={() => handleTabUpdate(tabId)}
          style={{
            width: '100%',
            maxWidth: '100%',
            minWidth: 0,
            minHeight: 50,
            marginLeft: 0,
            marginTop: 0,
            marginBottom: 0,
          }}
          loadingButtonStyle={{
            width: '100%',
            maxWidth: '100%',
            minWidth: 0,
            minHeight: 50,
            marginLeft: 0,
            marginTop: 0,
            marginBottom: 0,
          }}
          loading={saving}
          disabled={buttonDisabled}
        />
      </div>
    </div>
  );
}
